import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=3aadb2b8"
import script from "./Course.vue?vue&type=script&lang=ts"
export * from "./Course.vue?vue&type=script&lang=ts"
import style0 from "./Course.vue?vue&type=style&index=0&id=3aadb2b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports